<template>
    <div class="com-codics-hbb-order-admin-goods-brand-body">
        <div class="com-codics-hbb-order-admin-goods-brand-bar-content">
            <MyButton style="float: left;" @click.native="addDialogVisible = true;">&#xe632; 添加品牌</MyButton>
            <!-- 添加表单 -->
            <el-dialog title="添加商品品牌" :visible.sync="addProductDialogVisibility" width="80%">
                <el-form :model="addForm">
                    <el-form-item label="品牌名称" :label-width="formLabelWidth">
                        <el-input v-model="addForm.l" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="商品父类" :label-width="formLabelWidth">
                        <el-cascader :options="productTypeList" :props="{ checkStrictly: true }" clearable
                            @change="handleSubCat"></el-cascader>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="addProductDialogVisibility = false">取 消</el-button>
                    <el-button type="primary" @click="addProductTypeFuc">确 定</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="com-codics-hbb-order-admin-goods-brand-bar-content com-codics-hbb-order-admin-goods-brand-bar-content2"
            style="margin-top: 10px;">
            <el-table :data="tableData" style="width: 100%;transition: .3s;" row-key="value"
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" show-expand-column default-expand-all
                @selection-change="handleSelectionChange">
                <el-table-column prop="value" label="ID" width="120" style="user-select: none;">
                </el-table-column>
                <el-table-column prop="label" label="名称" width="180">
                </el-table-column>
                <el-table-column prop="createtime" label="创建时间" width="280">
                    <template slot-scope="scope">
                        {{ initTime(scope.row.createtime) }}
                    </template>
                </el-table-column>
                <el-table-column align="right" label="操作" min-width="150">
                    <template slot-scope="scope">
                        <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info"
                            icon-color="red" title="您确定要删除当前品牌数据吗？删除后所有子品牌将一并删除！"
                            @confirm="deleteGoodsBrandFuc([scope.row.value])">
                            <MyButton v-show="scope.row.member != 0" size="small" type="danger" style="float: right;"
                                slot="reference">删除</MyButton>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <MyDialog v-model="addDialogVisible" title="添加商品品牌">
            <el-input v-model="addForm.label" size="small" placeholder="请输入品牌名称" clearable
                style="font-size: 12px;width:calc(50% - 7.5px) !important;margin-top:20px;" autocomplete="off"
                maxlength="15" show-word-limit></el-input>
            <el-cascader :options="tableData" placeholder="请选择上级品牌"
                style="font-size: 12px !important;width:calc(50% - 7.5px) !important;margin-top:20px;margin-left:15px;margin-bottom:100px;"
                clearable size="small"
                :props="{ value: 'value', label: 'label', checkStrictly: true, children: 'children' }"
                @change="selectChange">
            </el-cascader>
            <MyButton size="small" style="position:absolute !important;bottom:15px;right:15px;"
                @click.native="addGoodsBrandFuc">
                确认
            </MyButton>
        </MyDialog>
    </div>
</template>

<script>
import dayjs from 'dayjs';
import MyButton from '@/components/MyButton';
import MyDialog from '@/components/MyDialog';
import { addGoodsBrand, deleteGoodsBrand, updateGoodsBrand, listGoodsBrand } from '@/api';
export default {
    data() {
        return {
            addProductDialogVisibility: false,
            formLabelWidth: '60px',
            addDialogVisible: false,
            tableData: [],
            selectData: [],
            addForm: {
                label: '',
                pid: 0,
            }
        }
    },
    components: {
        MyButton,
        MyDialog
    },
    mounted() {

        this.listGoodsBrandFuc();

    },
    methods: {
        async listGoodsBrandFuc() {

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await listGoodsBrand();

            loading.close();

            if (data.code == 200) {

                this.tableData = data.data;

                this.initChildren(this.tableData);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async addGoodsBrandFuc() {

            if (this.addForm.label == '') {

                this.$message({
                    showClose: true,
                    message: '品牌名称不能为空！',
                    type: 'warning'
                });

                return;

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await addGoodsBrand(this.addForm);

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '添加品牌数据成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async deleteGoodsBrandFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要删除的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await deleteGoodsBrand({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: data.count + '条数据删除成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        initChildren(list) {

            for (var i = 0; i < list.length; i++) {

                if (list[i]?.children != null) {

                    // list[i].hasChildren = true;

                    this.initChildren(list[i].children);

                } else {

                    // delete list[i].children;

                }

            }

        },
        selectChange(val) {

            this.addForm.pid = val.length == 0 ? 0 : val[val.length - 1];

        },
        initTime(str) {
            return dayjs(str).format('YYYY-MM-DD HH:mm:ss');
        }
    }
}
</script>

<style>
.com-codics-hbb-order-admin-goods-brand-body {
    height: calc(100vh - 100px);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    overflow-y: scroll;
    width: calc(100% + 20px);
    overflow-y: scroll;
    padding-right: 20px;
}

.com-codics-hbb-order-admin-goods-brand-bar-content {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: var(--sbar-bg-color);
    border-radius: 6px;
    border: 1px solid var(--sbar-l-3-color);
    padding: 15px;
    transition: .3s;
}

.com-codics-hbb-order-admin-goods-brand-bar-content2 {
    box-sizing: border-box;
    padding: 20px;
}

.com-codics-hbb-order-admin-goods-brand-bar-pick {
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-right: 15px;
}

.com-codics-hbb-order-admin-goods-brand-bar-input {
    width: 300px !important;
    position: relative;
    float: left;
    box-sizing: border-box;
}
</style>